import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { loadSalesTracker } from './app/core/utils/sales-tracker.loader';

// Sales Portal analytics tracker (URL per environment; see the loader).
loadSalesTracker();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
